<main class="main-home-secton">
  <mat-tab-group>
    <mat-tab>
      <ng-template mat-tab-label> Profile </ng-template>
      <div class="cancel-img">
        <img src="assets/images/Frame.png" alt="" (click)="backBtn()" />
      </div>
      <div class="Profile-content">
        <div class="incubuter-logo">
          <img
            [src]="profileView.incubatorLogoFileName"
            alt=""
            class="img-fluid incubuter-img"
          />
          <h1 class="ml-5">{{ profileView.incubatorName }}</h1>
        </div>
        <div class="incubator-des">
          <div class="box-content" style="word-break: break-all">
            <p>{{ profileView.incubatorRegDesc }}</p>
          </div>
        </div>
        <div class="incubator-box">
          <div class="row about-height">
            <div class="col-lg-6 col-md-6">
              <div class="about-details">
                <div class="incubuter-sub-title">
                  <h5>Focus Sector</h5>
                </div>
                <div class="incubuter-details">
                  <p>{{ profileView.incubatorFocusedSector }}</p>
                </div>
              </div>
              <div class="about-details">
                <div class="incubuter-sub-title">
                  <h5>Available Facilities</h5>
                </div>
                <div class="incubuter-details">
                  <p>{{ profileView.incubatorFacilities }}</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6">
              <div class="about-details">
                <div class="incubuter-sub-title">
                  <h5>Scheme Available</h5>
                </div>
                <div class="incubuter-details">
                  <p>{{ profileView.incubatorProvidedSchemes }}</p>
                </div>
              </div>
              <div class="about-details">
                <div class="incubuter-sub-title">
                  <h5>Special recognitions received by the Incubator</h5>
                </div>
                <div class="incubuter-details">
                  <p>{{ profileView.specialReceivedIncubator }}</p>
                </div>
              </div>
              <div class="about-details">
                <div class="incubuter-sub-title">
                  <h5>Contact Info</h5>
                </div>
                <div class="incubuter-details">
                  <div
                    class="contact-name-div"
                    *ngIf="profileView.incubatorTeamPhone"
                  >
                    {{ profileView.incubatorTeamPhone }}
                  </div>
                  <div
                    class="contact-name-div"
                    *ngIf="profileView.incubatorTeamEmail"
                  >
                    {{ profileView.incubatorTeamEmail }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label> Event </ng-template>
      <div class="cancel-img">
        <img src="assets/images/Frame.png" alt="" (click)="backBtn()" />
      </div>
      <div
        class="container py-3 main-sec-container"
        style="height: 500px; overflow: auto"
      >
        <div class="row">
          <div
            class="col-lg-5 col-md-6 col-12 ml-5"
            *ngFor="let list of eventList; let i = index"
          >
            <div class="marquee-item">
              <div class="events-div">
                <div class="blog-img-div">
                  <img
                    [src]="list.eventImageName"
                    alt=""
                    class="img-fluid events-img"
                  />
                </div>
                <div class="event-titles">
                  <h5>{{ list.eventName }}</h5>
                  <span>{{ list.incubatorName }}</span>
                  <div class="event-footer mb-2">
                    <div class="event-time mt-5">
                      <i class="far fa-calendar-alt"></i>
                      <span class="ml-2 mr-2">{{ list.eventFromDate }}</span>
                      <div class="d-flex mt-2">
                        <i class="fas fa-map-marker-alt ms-1"></i>
                        <span class="ml-2" style="word-break: break-word">{{
                          showFullLocation[i]
                            ? list.eventLocation
                            : (list.eventLocation | slice : 0 : 20)
                        }}</span>
                      </div>
                    </div>
                    <div
                      class="event-location-footer"
                      *ngIf="shouldShowMore(list.eventLocation)"
                    >
                      <ng-container *ngIf="!showFullLocation[i]">
                        <a class="view-location" (click)="toggleLocation(i)"
                          >Show more</a
                        >
                      </ng-container>
                      <ng-container
                        *ngIf="showFullLocation[i]"
                        style="
                          overflow: auto; /* Enable scrolling */
                          max-height: 60px;
                        "
                      >
                        <a class="view-location" (click)="toggleLocation(i)"
                          >Show less</a
                        >
                      </ng-container>
                    </div>
                    <div class="border-line"></div>
                    <div class="event-register">
                      <button class="view-btn" (click)="viewEvent(list.id)">
                        Register Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center" *ngIf="eventList.length == 0">
          <div class="no-data-div image-align">
            <img
              src="assets/images/startupTn-new-logo.png"
              class="img-fluid"
              alt=""
            />
            <h6>Coming soon</h6>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label> Newsletters </ng-template>
      <div class="cancel-img">
        <img src="assets/images/Frame.png" alt="" (click)="backBtn()" />
      </div>
      <div *ngIf="token !== undefined">
        <div class="incu-newnwesletters">
          <div
            class="row"
            [ngClass]="{
              'd-none': roleValue === 'Incubator' && roleValue === 'Admin'
            }"
          >
            <div
              class="col-lg-4 col-md-6 col-6"
              *ngFor="let list of newsLetterList; let i = index"
            >
              <div class="card newsletter_dev">
                <div class="logo-image text-center">
                  <img [src]="list.incubatorLogoFile" alt="" />
                </div>
                <div style="padding: 20px">
                  <h5>{{ list.title }}</h5>
                  <div class="d-flex">
                    <span
                      ><span
                        style="font-size: 12px; color: gray; margin-left: 3px"
                        >Posted :</span
                      >{{ list.newsletterDate }}</span
                    >
                    <span class="ml-auto"
                      ><a
                        [href]="list.newsletterName"
                        target="_blank"
                        style="color: orange"
                        >View more</a
                      ></span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="!newsLetterList || newsLetterList.length === 0"
            class="no-data-div image-align text-center"
          >
            <img
              style="margin-top: 80px"
              src="assets/images/startupTn-new-logo.png"
              class="img-fluid"
              alt=""
            />
            <h6>Coming soon</h6>
          </div>
        </div>
      </div>
      <div *ngIf="token == undefined">
        <app-incu-newsletters
          incubatorName="{{ incubatorName }}"
          incubatorId="{{ incubatorId }}"
        ></app-incu-newsletters>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div class="text-center backnewbtn" style="margin-left: 200px">
    <button class="" mat-raised-button color="warn" (click)="backBtn()">
      Back
    </button>
  </div>
</main>
